// extracted by mini-css-extract-plugin
export default {"eventDescription":"fvWQm","sideBySide":"_2P8Ke","descriptionSpacing":"pDYGP"};